module.exports = __webpack_public_path__ + "img/holiday-inn-lisboa.18c47f4f.jpg";